import React, { useMemo } from 'react';
import {
  getOrderedDisplayableResponseEntries,
  parseResponseFields,
  UNANSWERED_PLACEHOLDER,
} from '../helpers/dynamicFormFields';

const isImageValue = (value) =>
  typeof value === 'string' &&
  (value.includes('data:image') ||
    value.includes('.png') ||
    value.includes('.jpg') ||
    value.includes('.jpeg'));

const isFileValue = (value) =>
  typeof value === 'string' &&
  (value.includes('.doc') ||
    value.includes('.docx') ||
    value.includes('.html') ||
    value.includes('.htm') ||
    value.includes('.odt') ||
    value.includes('.xls') ||
    value.includes('.xlsx') ||
    value.includes('ods') ||
    value.includes('.ppt') ||
    value.includes('.pptx') ||
    value.includes('.pdf') ||
    value.includes('.txt'));

const FormResponseFields = ({
  fields,
  formFieldsSections = {},
  formatText,
  definitionsReady = true,
}) => {
  const formatValue = (value) => {
    if (typeof formatText === 'function') {
      const formatted = formatText(value);
      return formatted === null || typeof formatted === 'undefined' ? value : formatted;
    }
    return value;
  };
  const entries = useMemo(() => {
    if (!definitionsReady) {
      return [];
    }

    const parsedFields = parseResponseFields(fields);
    const hasDefinitions =
      formFieldsSections && Object.keys(formFieldsSections).length > 0;

    return getOrderedDisplayableResponseEntries(parsedFields, formFieldsSections, {
      matchEditLayout: hasDefinitions,
      preserveResponseOrder: !hasDefinitions,
    });
  }, [fields, formFieldsSections, definitionsReady]);

  if (!definitionsReady) {
    return null;
  }

  let headingCount = 0;

  return (
    <>
      {entries.map((entry, inner_index) => {
        if (entry.isHeading) {
          headingCount += 1;
        }

        const isHeading = entry.isHeading;
        const isMainHeading =
          entry.key === 'headings' || entry.key.startsWith('headings_');
        const isTextHeading =
          entry.key === 'text_headings' || entry.key.startsWith('text_headings_');
        const isUnanswered = !!entry.isUnanswered;

        return (
          <div
            key={`${entry.key}-${inner_index}`}
            className="responses-content-box"
            style={{ marginTop: '12px' }}
          >
            <div className="responses-content-question">
              {!isHeading && <span>{inner_index + 1 - headingCount}</span>}
              {isMainHeading ? (
                <h6
                  className="text-capitalize"
                  style={{ fontSize: '20px', color: '#AA0061' }}
                >
                  {entry.value}
                </h6>
              ) : isTextHeading ? (
                <h6
                  className="text-capitalize"
                  style={{ fontSize: '16px', color: '#455c58' }}
                >
                  {entry.value}
                </h6>
              ) : (
                <h6 className="text-capitalize">{entry.label}</h6>
              )}
            </div>
            <div className="responses-content-answer">
              {!isHeading && (
                <img src="/img/bx_right-arrow-alt.svg" alt="" />
              )}
              {isUnanswered ? (
                <p style={{ color: '#888', fontStyle: 'italic' }}>
                  {UNANSWERED_PLACEHOLDER}
                </p>
              ) : isImageValue(entry.value) ? (
                <img
                  style={{ height: '40px', width: '51px' }}
                  src={entry.value}
                  alt=""
                />
              ) : isFileValue(entry.value) ? (
                <a role="button" href={entry.value} download>
                  <p>{entry.value.split('/')[entry.value.split('/').length - 1]}</p>
                </a>
              ) : (
                !isHeading && (
                  <p className={formatText ? 'preserve-white-space' : undefined}>
                    {formatValue(entry.value)}
                  </p>
                )
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FormResponseFields;
